module.exports = __webpack_public_path__ + "img/emba_c.9de41c3e.png";